import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-733716c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "event__content" }
const _hoisted_2 = { class: "class__information" }
const _hoisted_3 = { class: "event__name" }
const _hoisted_4 = { class: "class__informative" }
const _hoisted_5 = { class: "class__informative" }
const _hoisted_6 = { class: "class__informative" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "class__type" }, " Evento ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "event",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.redirect()))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass({ event__image: _ctx.image })
    }, null, 2),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("address", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.event.name), 1),
        _createElementVNode("span", _hoisted_4, " Local: " + _toDisplayString(_ctx.event.classes[0].location), 1),
        _createElementVNode("span", _hoisted_5, " Data: " + _toDisplayString(_ctx.formatDate(
              _ctx.event.classes[0].scheduleStart,
              _ctx.event.classes[0].scheduleEnd
            )), 1),
        _createElementVNode("span", _hoisted_6, " Horário: " + _toDisplayString(_ctx.formatOneTime(_ctx.event.classes[0].scheduleStartDateTime)) + " até " + _toDisplayString(_ctx.formatOneTime(_ctx.event.classes[0].scheduleEndDateTime)), 1)
      ]),
      _hoisted_7
    ])
  ]))
}